import {Component, inject, OnInit, output} from '@angular/core'
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms'
import {MatRadioButton, MatRadioChange, MatRadioGroup} from '@angular/material/radio'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'
import {tap} from 'rxjs/operators'
import {Plural} from '../../model/plural'
import {DataService} from '../../services/data.service'

@Component({
  selector: 'spb-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatRadioGroup,
    MatRadioButton
  ]
})
export class QuestionsComponent extends Plural implements OnInit {

  public stepValid = output<boolean>()

  public form = new FormGroup({
    q3: new FormControl<number>(-1, {
      nonNullable: true,
      validators: [Validators.required, Validators.min(0)]
    }),
    q4: new FormControl<number>(-1, {
      nonNullable: true,
      validators: [Validators.required, Validators.min(0)]
    }),
    q5: new FormControl<number>(-1, {
      nonNullable: true,
      validators: [Validators.required, Validators.min(0)]
    }),
    q6: new FormControl<number>(-1, {
      nonNullable: true,
      validators: [Validators.required, Validators.min(0)]
    })
  })

  private readonly dataService = inject(DataService)
  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  public changeRadioButton(event: MatRadioChange, question: number) {
    (this.form.controls as any)[`q${question}`].setValue(event.value)
    this.staticDataService.questions$.next(this.form.getRawValue())
  }

  public ngOnInit(): void {

    this.form.statusChanges
      .subscribe((v) => {
        this.stepValid.emit(v === 'VALID')
      })

    this.dataService.data$
      .pipe(
        this.takeUntilDestroyed(),
        tap(() => this.form.reset())
      )
      .subscribe(data => this.form.patchValue(data.questions))
  }
}
